var React = require('react');

function Triangle (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M237.497 53.6744L0 0H502.5L262.509 53.701C254.272 55.544 245.73 55.5349 237.497 53.6744Z","fill":"white"}));
}

Triangle.defaultProps = {"width":"500","height":"56","viewBox":"0 0 500 56","fill":"none"};

module.exports = Triangle;

Triangle.default = Triangle;
